import useIsLoggedIn from '~/client/hooks/user/useIsLoggedIn';
import Translate from '~/client/shared/i18n/Translate';
import LoginLink from './LoginLink';

type Props = { messageId: string };

const ClappsTooltipBody: FC<Props> = ({ messageId }) => {
  const isLoggedIn = useIsLoggedIn();
  return (
    <div className="grid gap-2">
      <h6 className="text-moon-16 font-medium text-bulma">
        <Translate id={`casino.LIKE_this_game`} />
      </h6>
      <span className="text-moon-14 font-medium text-trunks">
        <Translate id={messageId} />
      </span>
      {!isLoggedIn && <LoginLink />}
    </div>
  );
};

export default ClappsTooltipBody;
